import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { AntdModule } from './Antd.module';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { AppConfigService } from './shared/services/app-config.service';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MarketFanExplorationComponent } from './market-fan-exploration/component/market-fan-exploration/market-fan-exploration.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StandardTemplatesComponent } from './market-fan-exploration/component/standard-templates/standard-templates.component';
import { CustomQueryComponent } from './market-fan-exploration/component/custom-query/custom-query.component';
import { SchedulingComponent } from './market-fan-exploration/component/scheduling/scheduling.component';
import { SegmentSizeAnalyzerComponent } from './market-fan-exploration/component/segment-size-analyzer/segment-size-analyzer.component';
import { HistoryComponent } from './market-fan-exploration/component/history/history.component';
import { SchedulerHistoryComponent } from './market-fan-exploration/component/history/scheduler-history/scheduler-history.component';
import { WorkbenchHistoryComponent } from './market-fan-exploration/component/history/workbench-history/workbench-history.component';
import { SegmentHistoryComponent } from './market-fan-exploration/component/history/segment-history/segment-history.component';
import { WorkbenchViewModalComponent } from './market-fan-exploration/component/history/modal/workbench-view-modal/workbench-view-modal.component';
import { WorkbenchQueryResultComponent } from './market-fan-exploration/component/history/modal/workbench-query-result/workbench-query-result.component';
import { SegmentViewModalComponent } from './market-fan-exploration/component/history/modal/segment-view-modal/segment-view-modal.component';
import { CreateScheduleModalComponent } from './market-fan-exploration/component/create-schedule-modal/create-schedule-modal.component';
import { AuthService } from './shared/services/auth.service';
import { LoginComponent } from './shared/components/login/login.component';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { MarketOverviewComponent } from './market-overview/component/market-overview/market-overview.component';
import { HomeComponent } from './home/component/home/home.component';
import { MatchSchedulesComponent } from './home/component/match-scheduling/match-schedules.component';
import { MarketingRequestsComponent } from './marketing-requests/component/marketing-requests/marketing-requests.component';
import { MarketingRequestComponent } from './marketing-requests/component/marketing-request/marketing-request.component';
import { MarketingQuotaComponent } from './marketing-requests/component/marketing-quota/marketing-quota.component';
import { ResourcesComponent } from './resources/component/resources/resources.component';
import { MarketInsightsComponent } from './market-insights/component/market-insights/market-insights.component';
import { ChartsComponent } from './market-insights/component/charts/charts.component';
import { DashboardsComponent } from './market-insights/component/dashboards/dashboards.component';
import { CreateChartComponent } from './market-insights/component/create-chart/create-chart.component';
import { ChartDetailsComponent } from './market-insights/component/chart-details/chart-details.component';
import { BuildChartComponent } from './market-insights/component/build-chart/build-chart.component';
import { ChartConfigComponent } from './market-insights/component/chart-config/chart-config.component';
import { ChartPreviewComponent } from './market-insights/component/chart-preview/chart-preview.component';
import { ViewDashboardsComponent } from './market-insights/component/view-dashboards/view-dashboards.component';
import { CreateDashboardComponent } from './market-insights/component/create-dashboard/create-dashboard.component';
import { DashboardPreviewComponent } from './market-insights/component/dashboard-preview/dashboard-preview.component';

const appConfigInit = (appConfig: AppConfigService, authService: AuthService) => {
  return async () => {
    await appConfig.loadAppConfig(authService);
    await authService.fetchUserDetails();
    const orgId = authService.getUserInfo()?.['custom:orgId']?.trim() || 'nfl';
    return appConfig.initializeTheme(orgId);
  };
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function authInterceptorInit(auth: AuthInterceptor): () => void {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  return () => {};
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    MatchSchedulesComponent,
    MarketOverviewComponent,
    MarketFanExplorationComponent,
    StandardTemplatesComponent,
    CustomQueryComponent,
    SchedulingComponent,
    SegmentSizeAnalyzerComponent,
    HistoryComponent,
    SchedulerHistoryComponent,
    WorkbenchHistoryComponent,
    SegmentHistoryComponent,
    WorkbenchViewModalComponent,
    WorkbenchQueryResultComponent,
    SegmentViewModalComponent,
    CreateScheduleModalComponent,
    LoginComponent,
    MarketingRequestsComponent,
    MarketingRequestComponent,
    MarketingQuotaComponent,
    ResourcesComponent,
    MarketInsightsComponent,
    ChartsComponent,
    DashboardsComponent,
    BuildChartComponent,
    CreateChartComponent,
    ChartDetailsComponent,
    ChartConfigComponent,
    ChartPreviewComponent,
    CreateDashboardComponent,
    DashboardPreviewComponent,
    ViewDashboardsComponent,
    // Add other components, directives, and pipes here
  ],
  imports: [
    BrowserModule,
    RouterModule,
    AppRoutingModule,
    AntdModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    SharedModule,
    // Add other modules here
  ],
  bootstrap: [AppComponent],
  providers: [
    provideAnimationsAsync(),
    provideHttpClient(),
    { provide: APP_INITIALIZER, useFactory: appConfigInit, multi: true, deps: [AppConfigService, AuthService] },
    { provide: APP_INITIALIZER, useFactory: authInterceptorInit, multi: true, deps: [AuthInterceptor] },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [WorkbenchViewModalComponent],
})
export class AppModule {}
